import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("outsidertoken");
    if (token == undefined) {
        token = "";
    }
    config.headers.Authorization = "Bearer "+token;
    return config;
}, function (error) {
    return Promise.reject(error);
});

// export const uri = 'http://localhost:5000'; 
// export const uri = 'http://api.outsider.isleg.com';
export const uri = '';

export const accountLogin = (params, callback) => get('/account/Login', params, callback);
export const accountGetIsOnline = (params, callback) => get('/account/GetIsOnline', params, callback);
export const accountSetIsOnLine = (params, callback) => get('/account/SetIsOnLine', params, callback);
export const accountSetPwd = (params, callback) => get('/account/SetPwd', params, callback);


export const billGetMyWithdraw = (params, callback) => get('/Bill/GetMyWithdraw', params, callback);
export const billReview = (params, callback) => get('/Bill/Review', params, callback);
export const billPassBatch = (params, callback) => get('/Bill/PassBatch', params, callback);
export const billConfrim = (params, callback) => get('/Bill/Confrim', params, callback);
export const billGet = (params, callback) => get('/Bill/Get', params, callback);
export const billHeartbeat = (params, callback) => get('/Bill/Heartbeat', params, callback);


export const orderGet = (params, callback) => get('/Order/Get', params, callback);
export const orderGetTodayErrorNum = (params, callback) => get('/Order/GetTodayErrorNum', params, callback);
export const orderOver = (params, callback) => get('/Order/Over', params, callback);
export const orderPass = (params, callback) => get('/Order/Pass', params, callback);
export const orderGetOk = (params, callback) => get('/Order/GetOk', params, callback);


export const get = (api, params, callback) => axios.get(uri + api, {
    params: params
}).then(res => {
    callback(res.data);
});

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
        callback(res.data);
});
